import logo from '../../../../assets/images/logo.png';
import {
  getCompanyDepositsLink,
  getCompanyLink,
  getPaymentReportLink,
  getRedeemableStoreCouponHistoriesLink,
} from '../../../../utils/getLinks';

export const LOGO_IMG = logo;

export const BOTTOM_NAV_MENU_ITEMS = [
  {
    img: 'house',
    content: 'ホーム',
    link: getPaymentReportLink(),

    isExternal: false,
  },
  {
    img: 'notepadText',
    content: '地域ギフト利用履歴',
    link: getRedeemableStoreCouponHistoriesLink(),
    isExternal: false,
  },
  {
    img: 'chartLine',
    content: '入金一覧',
    link: getCompanyDepositsLink(),
    isExternal: false,
  },
  {
    img: 'store',
    content: '事業者情報',
    link: getCompanyLink(),

    isExternal: false,
  },
  {
    img: 'mailPlus',
    content: 'お問い合わせ',
    link: 'https://example.com/',
    isExternal: true,
  },
];
